import React from "react";

const SignInModal = () => {
  return (
    <div id={"choose-your-goal-modal"} className="reveal-modal new-modal middling" data-reveal>
      <div className="modal-body">
        <div className="modal-close">
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content">
          <div className="row">
            <div className="large-12 columns text-center">
              <img src="https://public.cureus.com/authors-hub/goal-modal-img.png" />
            </div>
            <div className="large-12 columns text-center">
              <h4>Please sign up to select your goals</h4>
              <p>
                Already have an account?&nbsp;
                <a href={`/users/sign_in?return_to=/authors_hub`}>Sign in.</a>
              </p>
            </div>
          </div>
          <div className="modal-footer text-center">
          <a className="button secondary cancel-modal" href="#">Cancel</a>
          <a className="button" href="/registrations/sign_up">Join Now</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignInModal